import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';
import { WorkOrder } from '../types';

type Body = {
  effectiveWorkers?: number;
  employees?: number;
  agencyWorkers?: number;
  students?: number;
  locations?: boolean;
  multisite?: boolean;
  tempLocations?: boolean;
  comment?: string;
};

export const updateAuditorVisitWorkOrder = async ({
  visitId,
  data,
}: {
  visitId: string;
  data: Body;
}): Promise<WorkOrder> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/${visitId}/work-order`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as WorkOrder;
  return response;
};
